module.exports = __webpack_public_path__ + "img/UnderTriangleRed.754e9f2c.png";